import { useEffect } from 'react';

import { useSetLeaseDetailsSubmitLock } from '@/modules/application-tracker/components/lease-form';

import {
  useInviteEligibilityCheck,
  type InviteEligibilityRowFilter,
} from '../hooks/use-invite-eligibility-check';

type InviteEligibilityControllerProps = {
  /**
   * Defaults to every client-valid email (create invite).
   * Edit invite passes `includeEditInviteEligibilityRow` so unchanged recipients stay out.
   * Pass a stable function — an inline function resets the debounce on every render.
   */
  includeRow?: InviteEligibilityRowFilter;
};

/**
 * Mounts once inside the invite form (FormProvider) to own the eligibility
 * query side effects — syncing block outcomes onto email fields as RHF errors.
 * Banners read the same React Query cache via {@link useInviteEligibilityCheck}.
 */
export function InviteEligibilityController({ includeRow }: InviteEligibilityControllerProps) {
  const { hasBlock } = useInviteEligibilityCheck({ syncFieldErrors: true, includeRow });
  const setSubmitLocked = useSetLeaseDetailsSubmitLock();

  useEffect(() => {
    setSubmitLocked(hasBlock);
    return () => setSubmitLocked(false);
  }, [hasBlock, setSubmitLocked]);

  return null;
}
